import { render, staticRenderFns } from "./RoutingAreaForm.vue?vue&type=template&id=442c8a90&"
import script from "./RoutingAreaForm.vue?vue&type=script&lang=js&"
export * from "./RoutingAreaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports